import type { ContractorAgreementFields } from '../types/contractorOnboard';

/** Day rate from a signed agreement when pay unit is per day. */
export function dayRateFromAgreementFields(
  fields: Pick<ContractorAgreementFields, 'payAmount' | 'payUnit'>,
): number | null {
  if (fields.payUnit !== 'day') return null;
  const amount = Number(fields.payAmount) || 0;
  return amount > 0 ? amount : null;
}
